/* Checkout bypass — Yeyeo hotfix 2026-05-26
 * The third-party app LogBase Selleasy (lb-upsell-360) hijacks the cart
 * Checkout button via a click listener (attribute lb-upsell-default-checkout-listener).
 * With its upsell modal hidden site-wide by checkout-fix.css, the listener
 * runs but never resolves to a navigation. This script catches the click
 * BEFORE Selleasy (capture phase, useCapture=true) and forces native
 * navigation to /checkout, bypassing the hijack entirely.
 *
 * Safe even if Selleasy is uninstalled: the early-return preserves any
 * non-checkout clicks; the explicit /checkout nav matches Shopify default behavior.
 */
(function () {
  'use strict';

  function isCheckoutBtn(el) {
    if (!el || el.nodeType !== 1) return false;
    return (
      el.id === 'CartDrawer-Checkout' ||
      el.id === 'checkout' ||
      el.getAttribute('name') === 'checkout' ||
      (el.classList && (
        el.classList.contains('cart__checkout-button') ||
        el.classList.contains('cart-drawer__checkout')
      ))
    );
  }

  function handleClick(evt) {
    var path = evt.composedPath ? evt.composedPath() : [];
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      if (isCheckoutBtn(path[i])) { btn = path[i]; break; }
    }
    if (!btn) {
      // Fallback: walk up from evt.target
      var t = evt.target;
      while (t && t !== document) {
        if (isCheckoutBtn(t)) { btn = t; break; }
        t = t.parentNode;
      }
    }
    if (!btn) return;

    // Stop Selleasy's bubbling-phase listener from running.
    evt.stopImmediatePropagation();
    evt.preventDefault();

    // Strip Selleasy's marker attribute so it never re-attaches.
    try { btn.removeAttribute('lb-upsell-default-checkout-listener'); } catch (e) {}

    // Navigate to /checkout — Shopify redirects to the active checkout
    // (e.g. /checkouts/cn/...) using the current cart session.
    window.location.href = '/checkout';
  }

  // Register on capture phase so we run before any bubbling-phase hijack.
  document.addEventListener('click', handleClick, true);
  // Touch events go through click on mobile, but register touchend as a belt too.
  document.addEventListener('touchend', function (evt) {
    var path = evt.composedPath ? evt.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (isCheckoutBtn(path[i])) {
        // Let the synthetic click event handle nav (above) — but if Selleasy
        // listens to touchend specifically, block them here too.
        evt.stopImmediatePropagation();
        return;
      }
    }
  }, true);
})();
